import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

import cityImg1 from "../../../assets/images/city-1.jpg";
import cityImg2 from "../../../assets/images/city-2.jpg";
import cityImg3 from "../../../assets/images/city-3.jpg";
import cityImg4 from "../../../assets/images/city-4.jpg";
import "./PropertyByCity.css";

const CITIES = [
  { name: "Anand Vihar", image: cityImg1 },
  { name: "Laxmi Nagar", image: cityImg2 },
  { name: "Ghaziabad", image: cityImg3 },
  { name: "Gautam Buddha Nagar", image: cityImg4 },
];

const CityCard = ({ name, image, count }) => (
  <Link to="/login" className="pbc__card">
    <img src={image} alt={name} className="pbc__card-img" />
    <div className="pbc__card-overlay" />
    <div className="pbc__card-body">
      <span className="pbc__card-count">
        {count === null ? "Loading..." : `${count} Properties`}
      </span>
      <h3 className="pbc__card-name">{name}</h3>
      <span className="pbc__card-cta">
        Explore
        <span className="pbc__card-cta-line" />
        <ArrowRight size={13} strokeWidth={2.5} />
      </span>
    </div>
  </Link>
);

const PropertyByCity = () => {
  const [propertyCounts, setPropertyCounts] = useState({});
  const baseUrl = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchPropertyCounts = async () => {
      const counts = {};
      await Promise.all(
        CITIES.map(async (city) => {
          try {
            const response = await fetch(`${baseUrl}/all/property/count`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ city: city.name }),
            });
            const data = await response.json();
            counts[city.name] = data.propertyCount || "0";
          } catch (error) {
            console.error(`Error fetching count for ${city.name}:`, error);
            counts[city.name] = "0";
          }
        }),
      );
      setPropertyCounts(counts);
    };

    fetchPropertyCounts();
  }, []);

  return (
    <section className="pbc">
      <div className="pbc__container">
        <div className="pbc__header">
          <span className="pbc__label">Explore Locations</span>
          <h2 className="pbc__title">
            Properties by <em>Cities</em>
          </h2>
        </div>
        <div className="pbc__grid">
          {CITIES.map((city) => (
            <CityCard
              key={city.name}
              name={city.name}
              image={city.image}
              count={propertyCounts[city.name] ?? null}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyByCity;
